import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { onMounted, ref } from "vue";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";

interface Tag {
  name: string;
  enabled: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsView',
  props: {
  type: { type: String, required: true },
  id: { type: Number, required: true },
},
  setup(__props) {

const props = __props;



const isLoading = ref(false);

const selectedTags = ref<string[]>([]);
const tags = ref<Tag[]>([]);

onMounted(async () => {
  fetchData();
});

const fetchData = async () => {
  isLoading.value = true;
  try {
    // 获取当前实体的标签状态 - 这个API已经返回了完整的标签列表和状态
    const entityTags = await TenantGlobalService.getTagsById({
      type: props.type,
      rowId: props.id,
    });

    // 直接使用API返回的数据，因为它已经包含了enabled状态
    tags.value = entityTags;

    // 设置选中的标签名称数组（用于el-checkbox-group的v-model）
    selectedTags.value = entityTags
      .filter((tag: Tag) => tag.enabled)
      .map((tag: Tag) => tag.name);

    console.log("Tags:", tags.value);
    console.log("Selected tags:", selectedTags.value);
  } catch (error) {
    console.error("Error fetching tags:", error);
  } finally {
    isLoading.value = false;
  }
};

const updateTags = async (item: Tag) => {
  console.log("Update tags", item);

  // 切换enabled状态
  const isNowEnabled = selectedTags.value.includes(item.name);
  item.enabled = isNowEnabled;

  const res = await TenantGlobalService.updateTagsById({
    type: props.type,
    rowId: props.id,
    name: item.name,
    enabled: isNowEnabled,
  });

  console.log("Update result:", res);
};

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createBlock(_component_el_checkbox_group, {
    modelValue: selectedTags.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTags).value = $event))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (item, index) => {
        return (_openBlock(), _createBlock(_component_el_checkbox, {
          disabled: isLoading.value,
          key: index,
          label: item.name,
          onChange: ($event: any) => (updateTags(item))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["disabled", "label", "onChange"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})